// src/pages/ProfileDetailPage.jsx
import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Container, Paper, useTheme } from "@mui/material";

import { useProfileData } from "../../../context/ProfilesContext";

import ProfileHeader from "../profile-detail-page/profile-detail/ProfileHeader";

import ProfileTabs from "../profile-detail-page/profile-detail/ProfileTabs";
import LoadingState from "../profile-detail-page/profile-detail/LoadingState";
import ErrorState from "../profile-detail-page/profile-detail/ErrorState";
import { getGenderInfo } from "../profile-detail-page/profile-detail/utils/profileHelpers";

function ProfileDetailPage() {
  const { id } = useParams();
  const navigate = useNavigate();
  const theme = useTheme();
  const profile = useProfileData(id);
  const [activeTab, setActiveTab] = useState(0);
  const [imageError, setImageError] = useState(false);

  useEffect(() => {
    setImageError(false);
  }, [profile]);

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  const handleImageError = () => {
    setImageError(true);
  };

  // Loading state
  if (!profile) {
    return <LoadingState />;
  }

  // Error state
  if (!profile || profile.error) {
    return <ErrorState id={id} navigate={navigate} theme={theme} />;
  }

  const genderInfo = getGenderInfo(profile, theme);

  return (
    <Container maxWidth="lg" sx={{ py: 4 }}>
      <Paper elevation={0} sx={{
        borderRadius: 3,
        overflow: 'hidden',
        border: `1px solid ${theme.palette.divider}`,
        backgroundColor: theme.palette.background.paper,
        boxShadow: theme.shadows[2],
      }}>
        <ProfileHeader
          profile={profile}
          genderInfo={genderInfo}
          imageError={imageError}
          onImageError={handleImageError}
          navigate={navigate}
        />

        <ProfileTabs
          activeTab={activeTab}
          onTabChange={handleTabChange}
          profile={profile}
          genderInfo={genderInfo}
        />
      </Paper>
    </Container>
  );
}

export default ProfileDetailPage;